<template>
  <v-layout class="grey lighten-4 pa-3" column>
    <div v-if="tabs.length > 1">
      <v-tabs
        v-model="activeTab"
        grow>

        <v-tab v-for="(tab, index) in tabs" :key="`tab-${index}`" :to="{ name: tab.name }">
          {{ $t(tab.tabMenu) }}
        </v-tab>
      </v-tabs>

      <v-tabs-items
        v-model="activeTab"
        touchless>
        <v-tab-item
          transition="fade-transition"
          reverse-transition="fade-transition"
          class="grey lighten-4"
          v-for="(tab, index) in tabs"
          :key="`item-${index}`"
          :value="tab.route">
          <router-view v-if="tab.route === activeTab" />
        </v-tab-item>
      </v-tabs-items>
    </div>

    <div v-else>
      <router-view />
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'Menu',
  data () {
    return {
      activeTab: ''
    }
  },
  computed: {
    tabs () {
      const tabs = [
        // { tabMenu: 'menu.menu.menu', name: 'Menu', route: `/menu/sheet`, roles: ['manager', 'chef'] },
        { tabMenu: 'menu.menu.sales', name: 'Dishes', route: `/menu/dishes`, roles: ['manager', 'buyer'] }
      ]
      return tabs.filter(tab => tab.roles.includes(this.$is()))
    },
    area () {
      return this.$route.params.area
    }
  }
}
</script>
